"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var theme_1 = require("../theme");
var Typography_1 = __importDefault(require("../Typography"));
var Icon_1 = __importDefault(require("../Icon"));
var react_2 = require("@emotion/react");
var Avatar_1 = __importDefault(require("../Avatar"));
var getCSSRules = function (theme, _a) {
    var size = _a.size;
    return ({
        tag: {
            borderRadius: 100,
            color: theme.colors.Grey[900],
            marginRight: 4,
            padding: size === 'regular' ? '6px 12px' : '3px 10px',
            minWidth: 18,
            display: 'inline-flex',
            boxSizing: 'border-box',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& svg': { verticalAlign: 'top' },
        },
        icon: {
            marginLeft: 4,
            marginTop: size === 'regular' ? 2 : 0,
        },
        avatar: { paddingRight: 6 },
    });
};
var defaultProps = {
    size: 'regular',
};
var Tag = function (props) {
    var theme = (0, react_2.useTheme)();
    var onRemove = props.onRemove, label = props.label, className = props.className, id = props.id, color = props.color, style = props.style, size = props.size, avatar = props.avatar, rest = __rest(props, ["onRemove", "label", "className", "id", "color", "style", "size", "avatar"]);
    var styles = getCSSRules(theme, props);
    var themeColor = (0, react_1.useMemo)(function () {
        return color
            ? (0, theme_1.getThemeColorFromAlias)(color, theme.colors)
            : theme.colors.Grey[100];
    }, [color, theme.colors]);
    return ((0, jsx_runtime_1.jsx)(react_2.ClassNames, { children: function (_a) {
            var css = _a.css;
            return ((0, jsx_runtime_1.jsxs)("span", __assign({ css: styles.tag, className: className, style: __assign({ background: themeColor }, style) }, rest, { children: [avatar && ((0, jsx_runtime_1.jsx)(Avatar_1.default, { src: avatar, size: "sm", fill: true, style: styles.avatar }, void 0)), typeof label === 'string' ? ((0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ variant: size === 'regular' ? 'textMedium' : 'textSmall' }, { children: label }), void 0)) : (label), onRemove && ((0, jsx_runtime_1.jsx)(Icon_1.default, { name: 'remove', onClick: function (e) { return onRemove(e, id); }, size: 'sm', className: css(styles.icon) }, void 0))] }), void 0));
        } }, void 0));
};
Tag.defaultProps = defaultProps;
exports.default = Tag;
//# sourceMappingURL=index.js.map